<template>
  <Tooltip
    v-if="word"
    :show="show"
    :position="position"
    @mouseenter="$emit('enter-tooltip', word)"
    @mouseleave="$emit('leave-tooltip', word)"
  >
    <div>
      <span :style="{ color: color(word.key) }">{{ word.key }}</span>
    </div>
    <div>
      {{ $t("wordcloud.occurrenceIn") }}
      <span>{{ poems.length }}</span>
      {{ $tc("pluralization.poem", poems.length) }}
    </div>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">{{ $t("data.title") }}</th>
            <th class="text-left">{{ $t("data.year") }}</th>
            <!-- <th class="text-left">{{ $t("data.poemBeginning") }}</th> -->
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(d, i) in poems"
            :key="i"
            :style="{
              cursor: sankeyThemesSet.has(word.key) ? 'pointer' : 'default'
            }"
            :class="{
              'v-data-table__selected': d === pickedPoem
            }"
            @mouseenter="
              sankeyThemesSet.has(word.key) ? $emit('enter-poem', d) : () => {}
            "
            @mouseleave="
              sankeyThemesSet.has(word.key) ? $emit('leave-poem') : () => {}
            "
            @click="
              sankeyThemesSet.has(word.key) ? $emit('click-poem', d) : () => {}
            "
          >
            <td>{{ d["Titel"] }}</td>
            <td>{{ d.year ? d.year : $t("data.unknown") }}</td>
            <!-- <td>{{ d.firstSentence }}</td> -->
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </Tooltip>
</template>

<script>
import Tooltip from "@/components/Tooltip.vue";

export default {
  components: {
    Tooltip
  },
  props: {
    word: {
      type: Object,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    position: {
      type: Array,
      default: () => [9999, 9999]
    },
    color: {
      type: Function,
      required: true
    },
    sankeyThemesSet: {
      type: Set,
      default: () => new Set()
    },
    poems: {
      type: Array,
      default: () => []
    },
    pickedPoem: {
      type: Object,
      default: null
    }
  }
};
</script>
